import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

/**
 * Hotel Auth Service
 * Kullanıcıya özel otel işlemleri (kayıtlı misafirler listesi vb.)
 */
export const hotelAuthService = {
  /**
   * Kullanıcının kayıtlı misafirlerini getirir.
   * @param {Object} payload
   * @param {number} payload.UserId
   * @param {string} [payload.LanguageCode="tr"]
   * @param {number} [payload.AppVersion=0]
   * @param {Object} headers
   * @param {boolean} hasErrorHandler
   */
  getGuests: (
    payload = {},
    headers = {},
    hasErrorHandler = false,
  ) => {
    const normalizedPayload = {
      LanguageCode: "tr",
      AppVersion: 0,
      ...payload,
    };

    return request({
      method: HTTP_METHODS.POST,
      url: API_URLS.hotel.auth.getGuests,
      payload: normalizedPayload,
      headers,
      hasErrorHandler,
    });
  },
};
